module.exports = __webpack_public_path__ + "img/zh.bfa603f0.png";